import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("g", {
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "m13.4099 12.0002 4.3-4.29a1.0041 1.0041 0 0 0-1.42-1.42l-4.29 4.3-4.29-4.3a1.004 1.004 0 1 0-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 0 0-.2958.71 1 1 0 0 0 .2958.71 1 1 0 0 0 .71.2958 1 1 0 0 0 .71-.2958l4.29-4.3 4.29 4.3a1 1 0 0 0 .71.2958 1 1 0 0 0 .71-.2958 1 1 0 0 0 .2958-.71 1 1 0 0 0-.2958-.71z"
        })
    }, "0"),
    /*#__PURE__*/ _jsx("defs", {}, "1")
], "Close", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
